import { endOfDay, startOfMonth, subDays } from 'date-fns';

import type { RefuelsDateRange } from '../types/RefuelsDateRange.types';

export function getDefaultRefuelsDateRange(): RefuelsDateRange {
  const to = endOfDay(subDays(new Date(), 1));

  return { from: startOfMonth(to), to };
}

export function isSameDateRange(selectedDates: RefuelsDateRange | undefined, newDates: RefuelsDateRange) {
  return (
    selectedDates !== undefined &&
    selectedDates.from.getTime() === newDates.from.getTime() &&
    selectedDates.to.getTime() === newDates.to.getTime()
  );
}
